import { render, staticRenderFns } from "./CouponRulePopup.vue?vue&type=template&id=99abc866&scoped=true"
import script from "./CouponRulePopup.vue?vue&type=script&lang=js"
export * from "./CouponRulePopup.vue?vue&type=script&lang=js"
import style0 from "./CouponRulePopup.vue?vue&type=style&index=0&id=99abc866&prod&lang=less&scoped=true"
import style1 from "./CouponRulePopup.vue?vue&type=style&index=1&id=99abc866&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99abc866",
  null
  
)

export default component.exports